import React from 'react'
import './footer.css'

function Footer() {
    return (
        <div className="footer">
            Made with <i class="fa fa-heart pulse love"> </i> By Animesh Anand
        </div>
    )
}

export default Footer
